import React, { Component } from 'react';
import {
    getSelectableJurisdictionsAndBrands,
    getSelectedBrand,
    getSelectedJurisdiction
} from '../redux/selectors';
import { fetchJurisdictions, setJurisdiction } from '../redux/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { JurisdictionSelect } from '../../shared/jurisdiction-select/JurisdictionSelect';

class JurisdictionSelectContainer extends Component {
    componentDidMount() {
        this.props.fetchJurisdictions();
    }

    setJurisdiction({ jurisdiction, brand }) {
        this.props.setJurisdiction(jurisdiction, brand);
    }

    render = () => (
        <JurisdictionSelect
            jurisdictionsAndBrands={this.props.brandsAndJurisdictions}
            onJurisdictionChanged={jurisdiction =>
                this.setJurisdiction(jurisdiction)
            }
            jurisdiction={{
                jurisdiction: this.props.selectedJurisdiction,
                brand: this.props.selectedBrand
            }}
        />
    );
}

const mapStateToProps = state => {
    const brandsAndJurisdictions = getSelectableJurisdictionsAndBrands(state);
    const selectedJurisdiction = getSelectedJurisdiction(state);
    const selectedBrand = getSelectedBrand(state);

    return {
        brandsAndJurisdictions,
        selectedJurisdiction,
        selectedBrand
    };
};

const mapDispatchToProps = dispatch => ({
    fetchJurisdictions: () => dispatch(fetchJurisdictions()),
    setJurisdiction: (jurisdiction, brand) =>
        dispatch(setJurisdiction({ jurisdiction, brand }))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(JurisdictionSelectContainer));
